import React from 'react';
import { twMerge } from 'tailwind-merge';
import clsx from 'clsx';

import Loading from './Loading';

export default function InnerTabs({ tabs, isLoading }) {
  return (
    <div className="w-full h-full flex justify-start items-start relative">
      <div className="tabs tabs-lg tabs-lifted min-w-full">
        {tabs.map((tab, index) => (
          <React.Fragment key={`tabgroup-${tab.label}-${index}`}>
            <input
              type="radio"
              name="my_tabs_2"
              className="tab min-w-max"
              aria-label={tab.label}
              defaultChecked={tab.defaultChecked}
              onClick={tab.onClick}
            />
            <div
              id={`tabpanel-${index}`}
              className={twMerge(
                clsx('tab-content bg-base-100 border-base-300 rounded-box p-6'),
                tab.className,
              )}
            >
              {isLoading ? <Loading /> : tab.content}
            </div>
          </React.Fragment>
        ))}
      </div>
    </div>
  );
}
